import axios from 'axios';

/**
 * @typedef {import('./split-ship-api-types.d.ts').AdjustItemsRequest} AdjustItemsRequest
 */
/**
 * @typedef {import('./split-ship-api-types.d.ts').GetMissingLinksRequest} GetMissingLinksRequest
 */
/**
 * @typedef {import('./split-ship-api-types.d.ts').SoFpLink} SoFpLink
 */

/**
 * @param {AdjustItemsRequest} request
 * @returns {Promise<AxiosResponse<any>>}
 */
export const adjustItemsSync = (request) =>
  axios.post('/fulfillmentplan/items/sync', {
    ...request,
    itemAdjustmentStrategy: 'Bulk',
  });

/**
 * @param {GetMissingLinksRequest} request
 * @returns {Promise<AxiosResponse<SoFpLink[]>>}
 */
export const getMissingLinks = (request) => {
  return axios.post('fulfillmentplan/links/items', request);
};
